import { Validators } from '@angular/forms';
import { BrandModelDefaultValidators } from '../parcel-places.constants';
import { EParcelPlacesFormControlNames } from '../parcel-places.enums';
import { CodeUKTZEDGoodsType } from './ii-code-uktzed.shared';
import type { IICodeUKTZEDAffectedControl, IICodeUKTZEDCategoryData } from './ii-code-uktzed.shared';

export const codeUKTZEDMinLength = 8;
export const codeUKTZEDDestMinLength = 8;
export const codeUKTZEDMaxLength = 10;
export const codeUKTZEDCanadaLength = 10;
export const codeUKTZEDPattern = /^[0-9]{8,10}$/;
export const codeUKTZEDCanadaPattern = /^[0-9]{10}$/;
export const codeUKTZEDMoldovaPattern = /^[0-9]{10}$/;
export const codeUKTZEDUSAPattern = /^[0-9]{10}$/;
export const codeUKTZEDCommonValidators = [
  Validators.pattern(codeUKTZEDPattern),
  Validators.required,
]
export const codeUKTZEDDestCommonValidators = [
  Validators.pattern(codeUKTZEDPattern),
  Validators.required,
];


export const BrandModelAffectedControl: IICodeUKTZEDAffectedControl = {
  controlName: EParcelPlacesFormControlNames.brandModel,
  validators: [...BrandModelDefaultValidators, Validators.required],
  defaultValidators: [...BrandModelDefaultValidators],
};

export const CodeUKTZEDCategoryData: IICodeUKTZEDCategoryData = {
  [CodeUKTZEDGoodsType.Electronics]: {
    regexList: [/^84/, /^85/],
    categoryName: 'Електротехніка, цифрова техніка',
    categoryExample: 'приклад – Apple iPhone 16 Pro Max 256GB Silver',
    affectedControls: [BrandModelAffectedControl],
  },
  [CodeUKTZEDGoodsType.CarParts]: {
    regexList: [/^86/, /^87/, /^88/, /^89/],
    categoryName: 'Автомобільні запчастини',
    categoryExample: 'приклад – EDA PARTS PVG04473BA',
    affectedControls: [BrandModelAffectedControl],
  },
  [CodeUKTZEDGoodsType.Perfumes]: {
    regexList: [/^3303/],
    categoryName: 'Парфуми',
    categoryExample: 'приклад – Versace Bright Crystal 30ml',
    affectedControls: [BrandModelAffectedControl],
  },
  [CodeUKTZEDGoodsType.HandWatches]: {
    regexList: [/^91/],
    categoryName: 'Наручні годинники',
    categoryExample: 'приклад – Casio EDIFICE Classic',
    affectedControls: [BrandModelAffectedControl],
  },
};
